import React from 'react';

import { Switch, HashRouter } from 'react-router-dom';

import Route from './Route';

import SignIn from '~/pages/SignIn';

import Produtos from '~/pages/Produtos';

import Pedidos from '~/pages/Pedidos';
import Pedido from '~/pages/Pedido';

import MinhaSenha from '~/pages/MinhaSenha';

import Dashboard from '~/pages/Dashboard';

import Avisos from '~/pages/Avisos';

const Routes: React.FC = () => (
  <HashRouter>
    <Switch>
      <Route path="/" exact component={SignIn} />
      <Route path="/inicio" exact component={SignIn} />

      <Route path="/produtos" component={Produtos} isPrivate />
      <Route path="/pedidos" component={Pedidos} isPrivate />
      <Route path="/Pedido/:id" component={Pedido} isPrivate />

      <Route path="/minha-senha" component={MinhaSenha} isPrivate />

      <Route path="/dashboard" component={Dashboard} isPrivate />

      <Route path="/avisos" component={Avisos} isPrivate />
    </Switch>
  </HashRouter>
);

export default Routes;
